import React from 'react';
import { Card, Row, Col, Alert } from 'react-bootstrap';
import { NursePageHeader } from '../ui';
import { useNurseWorkspace } from '../nurseWorkspaceContext';

export default function NurseGuidePage() {
  const { copy } = useNurseWorkspace();
  const G = copy.GUIDE;
  const steps = Array.isArray(G.STEPS) ? G.STEPS : [];

  return (
    <div className="nr-guide recv-dash-pro--main">
      <NursePageHeader badge={G.BADGE} title={G.PAGE_TITLE} description={G.PAGE_SUBTITLE} />

      {G.INTRO ? (
        <Alert variant="success" className="border-0 shadow-sm mb-4 nr-guide-alert">
          {G.INTRO}
        </Alert>
      ) : null}

      <Row className="g-3">
        {steps.map((step) => (
          <Col md={6} key={step.title}>
            <Card className="border-0 shadow-sm h-100 nr-guide-card">
              <Card.Body>
                <Card.Title as="h2" className="h5">
                  {step.title}
                </Card.Title>
                <Card.Text className="text-muted small mb-0">{step.text}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
